import { WithTheme } from '@issuemanager/apps/client/theme';
import { Box, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorObject } from '../@types/forms';
import { SideToastWithIssueTypes } from './toasts';

const StyledBox = styled(Box)`
  position: fixed;
  right: 0;
  top: 0;
  margin-right: 22px;
  margin-top: 64px;
  z-index: 100;
`;

const StyledErrorTypography = styled(Typography)<WithTheme<TypographyProps>>(
  ({ theme }) => ({
    fontSize: theme.tokens.semantic.fontSize.text.body.value,
    fontWeight: theme.tokens.semantic.fontWeight.emphasis.value,
    color: theme.tokens.semantic.color.action.default.value,
  }),
);

type Props = {
  onClose: () => void;
  errors: ErrorObject;
};

export function ErrorFloatingCard(props: Props): React.JSX.Element {
  const { errors, onClose } = props;
  const { t } = useTranslation('common');
  const title = t('errors.form.toast.title');
  const subtitle = t('errors.form.toast.subtitle');

  const errorLabels = Object.values(errors).flatMap((fieldErrors) =>
    fieldErrors.map((error) => error.label),
  );

  const issueTypes =
    errorLabels.length > 0
      ? [
          {
            name: '',
            child: errorLabels.map((label) => (
              <StyledErrorTypography key={label}>{label}</StyledErrorTypography>
            )),
          },
        ]
      : [];

  return (
    <StyledBox>
      <SideToastWithIssueTypes
        title={title}
        subtitle={subtitle}
        issueTypes={issueTypes}
        onClose={onClose}
        type='error'
      />
    </StyledBox>
  );
}
